import { TmcContextService } from './../../../../common/tmc-context.service';
import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { TerminalContextConstants } from '@sdbn/tmc-common';

import { RegistrationTransportOption } from '../../../../model/terminal/transport-registration.model';

@Component({
    selector: 'app-transport-registration-summary',
    templateUrl: './transport-registration-summary.component.html',
    styleUrls: ['./transport-registration-summary.component.scss'],
    standalone: false
})
export class TransportRegistrationSummaryComponent extends AbstractWidgetComponent implements OnInit {

  gatekeeperMandatory: boolean;
  isUsingSmartphone: boolean;
  numberPlate: string;
  driver: string;
  carrier: string;
  orderReference: string;
  hintDrivers = new Array<string>();

  constructor(
    private tmcContextService: TmcContextService,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.gatekeeperMandatory = this.dashboardContext.getContextValue(TerminalContextConstants.gatekeeperMandatory);
    this.isUsingSmartphone = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication)
      === TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE;
    this.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
    this.driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
    this.carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
    this.orderReference = this.dashboardContext.getContextValue(TerminalContextConstants.orderReference);
    const selectedOptions = this.dashboardContext.getContextValue(TerminalContextConstants.selectedOptions);

    let hints = new Array<string>();

    console.log('selected options are', selectedOptions);

    for (const selectedOption of selectedOptions) {
      const to = this.findTransportOption(selectedOption);
      if (to != null) {
        if (this.translationService.translationExists(to.hintDriverDictionaryKey, this.translationService.language)) {
          hints.push(to.hintDriverDictionaryKey);
        }
      }
    }

    this.hintDrivers = hints;

  }

  private findTransportOption(selectedOption: RegistrationTransportOption) {
    for (const to of this.tmcContextService.getYardConfiguration().transportOptions) {
      if (to.id === selectedOption.transportOptionId) {
        return to;
      } else if (to.transportOptions != null)
        for (const childOption of to.transportOptions) {
          if (childOption.id === selectedOption.transportOptionId) {
            return childOption;
          }
        }
    }
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
